export function getFormattedTimezones() {
  try {
    return Intl.supportedValuesOf("timeZone").map((tz) => {
      const offset =
        new Intl.DateTimeFormat("en", {
          timeZone: tz,
          timeZoneName: "longOffset",
        })
          .formatToParts(new Date())
          .find((part) => part.type === "timeZoneName")?.value || "GMT+00:00";

      const formattedTimezone = `${tz} (${offset})`;

      return {
        value: formattedTimezone,
        label: formattedTimezone,
      };
    });
  } catch (error) {
    console.error("Failed to get formatted timezones:", error);
    return [];
  }
}
